export const FETCH_SUPPORT_INIT_ACTION = "FETCH_SUPPORT_INIT_ACTION";
export const FETCH_SUPPORT_SUCCESS_ACTION =
  FETCH_SUPPORT_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORT_FAIL_ACTION = FETCH_SUPPORT_INIT_ACTION + "_ERROR";

export const ADD_SUPPORT_INIT_ACTION = "ADD_SUPPORT_INIT_ACTION";
export const ADD_SUPPORT_SUCCESS_ACTION = ADD_SUPPORT_INIT_ACTION + "_SUCCESS";
export const ADD_SUPPORT_FAIL_ACTION = ADD_SUPPORT_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORT_ISSUE_INIT_ACTION =
  "FETCH_SUPPORT_ISSUE_INIT_ACTION";
export const FETCH_SUPPORT_ISSUE_SUCCESS_ACTION =
  FETCH_SUPPORT_ISSUE_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORT_ISSUE_FAIL_ACTION =
  FETCH_SUPPORT_ISSUE_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORT_CHAT_INIT_ACTION = "FETCH_SUPPORT_CHAT_INIT_ACTION";
export const FETCH_SUPPORT_CHAT_SUCCESS_ACTION =
  FETCH_SUPPORT_CHAT_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORT_CHAT_FAIL_ACTION =
  FETCH_SUPPORT_CHAT_INIT_ACTION + "_ERROR";

export const ADD_ISSUE_REPLY_INIT_ACTION = "ADD_ISSUE_REPLY_INIT_ACTION";
export const ADD_ISSUE_REPLY_SUCCESS_ACTION =
  ADD_ISSUE_REPLY_INIT_ACTION + "_SUCCESS";
export const ADD_ISSUE_REPLY_FAIL_ACTION =
  ADD_ISSUE_REPLY_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORT_AGENT_INIT_ACTION =
  "FETCH_SUPPORT_AGENT_INIT_ACTION";
export const FETCH_SUPPORT_AGENT_SUCCESS_ACTION =
  FETCH_SUPPORT_AGENT_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORT_AGENT_FAIL_ACTION =
  FETCH_SUPPORT_AGENT_INIT_ACTION + "_ERROR";

  export const FETCH_SUPPORT_CONTACTS_INIT_ACTION =
  "FETCH_SUPPORT_CONTACTS_INIT_ACTION";
export const FETCH_SUPPORT_CONTACTS_SUCCESS_ACTION =
  FETCH_SUPPORT_CONTACTS_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORT_CONTACTS_FAIL_ACTION =
  FETCH_SUPPORT_CONTACTS_INIT_ACTION + "_ERROR";

  export const FETCH_PROFILE_INIT_ACTION = "FETCH_PROFILE_INIT_ACTION";
  export const FETCH_PROFILE_SUCCESS_ACTION =
    FETCH_PROFILE_INIT_ACTION + "_SUCCESS";
  export const FETCH_PROFILE_FAIL_ACTION = FETCH_PROFILE_INIT_ACTION + "_ERROR";
  
  export const FETCH_SUPPRTADDAPT_INIT_ACTION = "FETCH_SUPPRTADDAPT_INIT_ACTION";
  export const FETCH_SUPPRTADDAPT_SUCCESS_ACTION =
    FETCH_SUPPRTADDAPT_INIT_ACTION + "_SUCCESS";
  export const FETCH_SUPPRTADDAPT_FAIL_ACTION = FETCH_SUPPRTADDAPT_INIT_ACTION + "_ERROR";
